import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { signal } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ProfilePersonalDataService {
  private readonly API_URL = environment.apiUrl;
  userSignal = signal<any | null>(null);
  constructor(private http: HttpClient) {}

  getUserById(userId: string) {
    return this.http.get<any>(`${this.API_URL}/users/${userId}`);
  }

  getCountries() {
    return this.http.get<any>(`${this.API_URL}/countries`);
  }

  updateUser(userId: string, payload: any) {
    return this.http.post<any>(`${this.API_URL}/users/${userId}`, payload);
  }

  loadUserById(userId: string) {
    return this.http.get<any>(`${this.API_URL}/users/${userId}`).subscribe((user) => {
      this.userSignal.set(user);

      if (user.data?.name) {
        console.log('Setting user full name in localStorage:', user.data.name);
        localStorage.setItem('user_full_name', user.data.name);
        location.reload();
      }
    });
  }
}
